<template>
  <div class="menu">
    <a href="/" class="logotype">
      <img v-if="!isOpen" src="../assets/img/Reformbanken-logo.svg" alt="logo">
    </a>
    <nav v-if="isOpen" class="nav">
      <div class="links">
        <router-link to="/" class="playfair-normal">Startsida</router-link>
        <router-link to="/om-reformbanken" class="playfair-normal">Om Reformbanken</router-link>
      </div>
    </nav>
    <div class="hamburger">
      <div @click="isOpen = !isOpen" id="nav-icon3" v-bind:class="{ open: isOpen }">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Hamburger',
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    tagLength () {
      return this.$store.state.currentTags.length
    }
  },
  props: []
}
</script>
<style lang="scss" scoped>
.menu img {
  width: 240px;
  position:absolute;
  top:15px;
  left:20px;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(0.98);
  }
}
.nav {
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  .links {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-right:120px;;
    padding-top: 19px;
    top: 0;
    right: 0px;
    z-index:999;
  }
  a {
    text-decoration: none;
    color: $darkGrey;
    font-size: 16px;
    margin-left: 20px;
  }
  a:hover {
    color: $purple;
  }
}
.hamburger {
  z-index: 99;
  width: 64px;
  height: 60px;
  top: 0px;
  right: 20px;
  margin-right: 10px;
  position: absolute;
  box-sizing: border-box;
  padding: 19px 10px 10px 16px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
/* Icon 1 */
#nav-icon3 {
  width: 40px;
  height: 40px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}
#nav-icon3 span {
  display: block;
  position: absolute;
  height: 2.2px;
  width: 100%;
  background: #2c3e50;
  border-radius: 0px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
 }
.open#nav-icon3 span {
  background-color: #2c3e50;
}
/* Icon 3 */
#nav-icon3 span:nth-child(1) {
  top: 0px;
}
#nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
  top: 10px;
}
#nav-icon3 span:nth-child(4) {
  top: 20px;
}
#nav-icon3.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
  background-color: #2c3e50;
}
#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #2c3e50;
}
#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: #2c3e50;
}
#nav-icon3.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
  background-color: #2c3e50;
}

@media #{$ipads} {
  .nav {
    justify-content: center;
    .links {
      margin-right: 10%;
    }
  }
  .menu img {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .hamburger {
    margin: 0;
    top:0;
    right:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger.vue